import { useQuery } from '@tanstack/react-query';
import { IEventStatus } from '@clickersphere/core/entities/IEventStatus';
import EventStatusService from '@clickersphere/core/services/EventStatusService';
import { useBuildQueryKey } from '../useBuildQueryKey';

export const EVENT_STATUS_QUERY_KEY = 'event-status';

export function useEventStatus() {
  const { buildQueryKey } = useBuildQueryKey();

  const {
    data: eventStatus,
    isSuccess: isEventStatusSuccess,
    isFetching: isEventStatusFetching,
    isLoading: isEventStatusLoading,
  } = useQuery<IEventStatus[]>({
    queryKey: buildQueryKey(EVENT_STATUS_QUERY_KEY),
    queryFn: () => EventStatusService.getAll(),
    staleTime: Infinity,
  });

  return {
    eventStatus,
    isEventStatusSuccess,
    isEventStatusFetching,
    isEventStatusLoading,
  };
}
